export default __webpack_public_path__ + "static/media/rope.81d6acca.svg";